import { IconsProps } from './IconsProps';

const Pin = ({
  className = '',
  viewBox = '0 0 36 36',
  width = 36,
  height = 36,
  onClick,
  svgFill = 'currentColor',
  ariaLabel,
  ariaHidden,
}: IconsProps) => {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      width={`${width}px`}
      height={`${height}px`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={onClick}
      fill={svgFill}
      aria-label={ariaLabel}
      aria-hidden={ariaHidden}
    >
      <path
        d="M17.9999 3C15.216 3.00338 12.5471 4.13711 10.5786 6.15262C8.6102 8.16812 7.50302 10.9008 7.50002 13.751C7.49745 15.0358 7.72236 16.3105 8.16389 17.5131C9.11792 20.4865 16.4554 30.095 17.2892 31.1803C17.3644 31.2783 17.46 31.3577 17.569 31.4131C17.6781 31.4684 17.7978 31.4981 17.9195 31.5H17.9311C18.0509 31.4998 18.1693 31.4728 18.2778 31.4208C18.3863 31.3688 18.4823 31.293 18.5592 31.1989C18.886 30.7974 26.5714 21.3244 27.6725 17.9332C28.3468 16.2988 28.6155 14.5189 28.4547 12.7523C28.2938 10.9858 27.7084 9.28742 26.7506 7.80878C25.7928 6.33014 24.4925 5.11716 22.9655 4.27808C21.4386 3.439 19.7325 2.99998 17.9995 3H17.9999ZM17.9999 19.8377C16.8242 19.8377 15.6748 19.4808 14.6972 18.8121C13.7196 18.1434 12.9577 17.1929 12.5077 16.0809C12.0577 14.9688 11.94 13.7451 12.1693 12.5645C12.3986 11.3839 12.9647 10.2994 13.796 9.44818C14.6273 8.59698 15.6865 8.0173 16.8396 7.78238C17.9928 7.54747 19.188 7.66797 20.2743 8.12852C21.3606 8.58908 22.2891 9.36897 22.9424 10.3698C23.5956 11.3706 23.9443 12.5472 23.9445 13.751C23.9425 15.3644 23.3156 16.9113 22.2012 18.0521C21.0868 19.193 19.5759 19.8348 17.9999 19.8367V19.8377Z"
        fill={svgFill}
      />
    </svg>
  );
};

export default Pin;
